export function isAuthRoute() {
    const pathname = window.location.pathname.toLowerCase();
    return pathname.startsWith('/admin-console') || pathname.startsWith('/console');
}
